// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Loader_loader__lzYRf::after {
  content: "";
  display: block;
  box-sizing: border-box;
  border-radius: 50%;
}

.Loader_loader__lzYRf.Loader_primary__Fqffl.Loader_small__VnRnG::after {
  width: 20px;
  height: 20px;
  border-top: 2px solid var(--primary-color);
  border-left: 2px solid var(--primary-color);
  border-right: 2px solid transparent;
  animation: Loader_spinner__VyDPj 0.6s linear infinite;
}
.Loader_loader__lzYRf.Loader_primary__Fqffl.Loader_normal__Da8Tc::after {
  width: 40px;
  height: 40px;
  border-top: 4px solid var(--primary-color);
  border-left: 4px solid var(--primary-color);
  border-right: 4px solid transparent;
  animation: Loader_spinner__VyDPj 0.6s linear infinite;
}
.Loader_loader__lzYRf.Loader_primary__Fqffl.Loader_big__SKcsd::after {
  width: 80px;
  height: 80px;
  border-top: 8px solid var(--primary-color);
  border-left: 8px solid var(--primary-color);
  border-right: 8px solid transparent;
  animation: Loader_spinner__VyDPj 0.6s linear infinite;
}
.Loader_loader__lzYRf.Loader_white__YPKLA.Loader_normal__Da8Tc::after {
  width: 40px;
  height: 40px;
  border-top: 4px solid #fff;
  border-left: 4px solid #fff;
  border-right: 4px solid transparent;
  animation: Loader_spinner__VyDPj 0.6s linear infinite;
}
.Loader_loader__lzYRf.Loader_white__YPKLA.Loader_big__SKcsd::after {
  width: 80px;
  height: 80px;
  border-top: 8px solid #fff;
  border-left: 8px solid #fff;
  border-right: 8px solid transparent;
  animation: Loader_spinner__VyDPj 0.6s linear infinite;
}

@keyframes Loader_spinner__VyDPj {
  to {
    transform: rotate(360deg);
  }
}
.Loader_message__JeTtg {
  font-size: 14px;
  text-align: center;
  font-weight: 400;
  margin-top: 20px;
}`, "",{"version":3,"sources":["webpack://./src/_common/components/Loader/Loader.module.scss"],"names":[],"mappings":"AAkBA;EACE,WAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;AAjBF;;AAGE;EACE,WANW;EAOX,YAPW;EAQX,0CAAA;EACA,2CAAA;EACA,mCAAA;EACA,qDAAA;AAAJ;AANE;EACE,WALY;EAMZ,YANY;EAOZ,0CAAA;EACA,2CAAA;EACA,mCAAA;EACA,qDAAA;AAQJ;AAdE;EACE,WAJS;EAKT,YALS;EAMT,0CAAA;EACA,2CAAA;EACA,mCAAA;EACA,qDAAA;AAgBJ;AAtBE;EACE,WALY;EAMZ,YANY;EAOZ,0BAAA;EACA,2BAAA;EACA,mCAAA;EACA,qDAAA;AAwBJ;AA9BE;EACE,WAJS;EAKT,YALS;EAMT,0BAAA;EACA,2BAAA;EACA,mCAAA;EACA,qDAAA;AAgCJ;;AAKA;EACE;IACE,yBAAA;EAFF;AACF;AAKA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAHF","sourcesContent":["@use 'sass:math';\n@import '@common/scss/_colors';\n\n$loader-small: 20px;\n$loader-normal: 40px;\n$loader-big: 80px;\n\n@mixin loader($color: $primary, $size: 40px, $border: math.div($size, 10)) {\n  &::after {\n    width: $size;\n    height: $size;\n    border-top: $border solid $color;\n    border-left: $border solid $color;\n    border-right: $border solid transparent;\n    animation: spinner 0.6s linear infinite;\n  }\n}\n\n.loader::after {\n  content: '';\n  display: block;\n  box-sizing: border-box;\n  border-radius: 50%;\n}\n\n.loader {\n  &.primary {\n    &.small {\n      @include loader($primary, $loader-small);\n    }\n\n    &.normal {\n      @include loader($primary, $loader-normal);\n    }\n\n    &.big {\n      @include loader($primary, $loader-big);\n    }\n  }\n\n  &.white {\n    &.normal {\n      @include loader(#fff, $loader-normal);\n    }\n\n    &.big {\n      @include loader(#fff, $loader-big);\n    }\n  }\n}\n\n@keyframes spinner {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.message {\n  font-size: 14px;\n  text-align: center;\n  font-weight: 400;\n  margin-top: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loader": `Loader_loader__lzYRf`,
	"primary": `Loader_primary__Fqffl`,
	"small": `Loader_small__VnRnG`,
	"spinner": `Loader_spinner__VyDPj`,
	"normal": `Loader_normal__Da8Tc`,
	"big": `Loader_big__SKcsd`,
	"white": `Loader_white__YPKLA`,
	"message": `Loader_message__JeTtg`
};
export default ___CSS_LOADER_EXPORT___;
